import React,{ Component } from "react";
import { InputField } from "../../../common/custom-form/input-filter-component";
import { Button } from "react-bootstrap";
import InvoiceComment from "../../../common/report/reports/Invoice/manage-invoice/invoice-comment.component";
import  InvoiceHistory from "../../../common/report/reports/Invoice/manage-invoice/invoice-history.component";
import { SelectField } from "../../../common/custom-form/select-filter.component";
import ManageLayout from "../../../common/report/details/manage-report.component";
import { OrderEmailValidator } from "./order-email-validator.component";
import { Selected_Index } from "../../../../constants/internal-constants";
export default class OrderSummary extends Component{
    constructor(props){
        super(props);
        this.getDataSelected=this.getDataSelected.bind(this);
        this.CloseForm=this.CloseForm.bind(this);
        this.state={
            selectFilter:[
                {
                    "FilterId":5,
                    "FilterName":"Account Number",
                    "FilterType":"Textbox",
                    "Page":"CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                },
                {
                    "FilterId":4,
                    "FilterName":"Circuit ID",
                    "FilterType":"Textbox","Page":
                    "CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                },
                {
                    "FilterId":7,
                    "FilterName":"Circuit Status",
                    "FilterType":"Textbox",
                    "Page":"CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                }
               ],
            filterSelected: "", 
            inputValue: "",
            invoiceDate: "",
            invoiceApproveDate: "",
            invoiceDueDate: "",
            billingPeriodDate: "",
            invoiceExpectedDate: "",
            rentalPeriodDate: "",
            actualInvoiceMonth: "",
            invoiceReceiptDate: "",
            beginDate: "",
            endDate: "",
            dataTable:[
                {              
                    HeaderItem:[
                        {
                            name:"Contract Name"
                        },
                        {
                            name:"Vendor"
                        }, {
                            name:"Status"
                        },
                        {
                            name:"Contract Name"
                        },
                        {
                            name:"Vendor"
                        }, {
                            name:"Status"
                        }, {
                            name:"Contract Name"
                        },
                        {
                            name:"Vendor"
                        }, {
                            name:"Status"
                        },
                        {
                            name:"Contract Name"
                        },
                        {
                            name:"Vendor"
                        }, {
                            name:"Status"
                        }, {
                            name:"Contract Name"
                        },
                        {
                            name:"Vendor"
                        }, {
                            name:"Status"
                        },
                        {
                            name:"Contract Name"
                        },
                        {
                            name:"Vendor"
                        }, {
                            name:"Status"
                        }, {
                            name:"Contract Name"
                        },
                        {
                            name:"Vendor"
                        }, {
                            name:"Status"
                        },
                        {
                            name:"Contract Name"
                        },
                        {
                            name:"Vendor"
                        }, {
                            name:"Status"
                        }
                    ],
                    dataItem:[
                        {            
                            columnItem1:"3G Hutchison (GB) Contract",
                            columnItem2: "3G Hutchison (GB)",
                            columnItem3: "Expired",
                            columnItem4:"3G Hutchison (GB) Contract",
                            columnItem5: "3G Hutchison (GB)",
                            columnItem6: "Expired",
                            columnItem7:"3G Hutchison (GB) Contract",
                            columnItem8: "3G Hutchison (GB)",
                            columnItem9: "Expired",
                            columnItem10:"3G Hutchison (GB) Contract",
                            columnItem11: "3G Hutchison (GB)",
                            columnItem12: "Expired",
                            columnItem13:"3G Hutchison (GB) Contract",
                            columnItem14: "3G Hutchison (GB)",
                            columnItem15: "Expired",
                            columnItem16:"3G Hutchison (GB) Contract",
                            columnItem17: "3G Hutchison (GB)",
                            columnItem18: "Expired",
                            columnItem19:"3G Hutchison (GB) Contract",
                            columnItem20: "3G Hutchison (GB)",
                            columnItem21: "Expired",
                            columnItem22:"3G Hutchison (GB) Contract",
                            columnItem23: "3G Hutchison (GB)",
                            columnItem24: "Expired"                          
                        }, {            
                            columnItem1:"3G Hutchison (GB) Contract",
                            columnItem2: "3G Hutchison (GB)",
                            columnItem3: "Expired",
                            columnItem4:"3G Hutchison (GB) Contract",
                            columnItem5: "3G Hutchison (GB)",
                            columnItem6: "Expired",
                            columnItem7:"3G Hutchison (GB) Contract",
                            columnItem8: "3G Hutchison (GB)",
                            columnItem9: "Expired",
                            columnItem10:"3G Hutchison (GB) Contract",
                            columnItem11: "3G Hutchison (GB)",
                            columnItem12: "Expired",
                            columnItem13:"3G Hutchison (GB) Contract",
                            columnItem14: "3G Hutchison (GB)",
                            columnItem15: "Expired",
                            columnItem16:"3G Hutchison (GB) Contract",
                            columnItem17: "3G Hutchison (GB)",
                            columnItem18: "Expired",
                            columnItem19:"3G Hutchison (GB) Contract",
                            columnItem20: "3G Hutchison (GB)",
                            columnItem21: "Expired",
                            columnItem22:"3G Hutchison (GB) Contract",
                            columnItem23: "3G Hutchison (GB)",
                            columnItem24: "Expired"         
                        },{            
                            columnItem1:"3G Hutchison (GB) Contract",
                            columnItem2: "3G Hutchison (GB)",
                            columnItem3: "Expired",
                            columnItem4:"3G Hutchison (GB) Contract",
                            columnItem5: "3G Hutchison (GB)",
                            columnItem6: "Expired",
                            columnItem7:"3G Hutchison (GB) Contract",
                            columnItem8: "3G Hutchison (GB)",
                            columnItem9: "Expired",
                            columnItem10:"3G Hutchison (GB) Contract",
                            columnItem11: "3G Hutchison (GB)",
                            columnItem12: "Expired",
                            columnItem13:"3G Hutchison (GB) Contract",
                            columnItem14: "3G Hutchison (GB)",
                            columnItem15: "Expired",
                            columnItem16:"3G Hutchison (GB) Contract",
                            columnItem17: "3G Hutchison (GB)",
                            columnItem18: "Expired",
                            columnItem19:"3G Hutchison (GB) Contract",
                            columnItem20: "3G Hutchison (GB)",
                            columnItem21: "Expired",
                            columnItem22:"3G Hutchison (GB) Contract",
                            columnItem23: "3G Hutchison (GB)",
                            columnItem24: "Expired"         
                        }           
                    ]
    
                }
            ],
            dataInfo:[
                {
                    "name " : "Johny Deep",
                    "date " : "June 08, 2021",
                    "time" : "4:00 PM",
                     "comment" :[
                         "Update-Circuit ID: 0",
                         "Order Submit Date: From: May 31, 2021 at 4:00PM TO: June 07, 2021 at 4:00 AM",
                         "Order Circuit Required Date: From: TO: June  07, 2021 at 4:00PM"
                     ]
                }
            ],
            selectedIndex:"0", 
            dataSelected:0,
            tableSelected:false,
            listTabInfo:{
                Tab:[
                    {
                        "id":"0",
                        "label":"Order Request Details"            
                    },
                    {
                        "id":"1",
                        "label":"Email Vendor"           
                    }, {
                        "id":"2",
                        "label":"History"           
                    }
                ]
            },
            dataInfo:[
                {
                    "name " : "Johny Deep",
                    "date " : "June 08, 2021",
                    "time" : "4:00 PM",
                     "comment" :[
                         "Update-Circuit ID: 0",
                         "Order Submit Date: From: May 31, 2021 at 4:00PM TO: June 07, 2021 at 4:00 AM",
                         "Order Circuit Required Date: From: TO: June  07, 2021 at 4:00PM"
                     ]
                }
            ],
            commentData:[
                {
                    "name " : "Johny Deep",
                    "date " : "June 08, 2021",
                    "time" : "4:00 PM",
                     "comment" :[
                         "Update-Circuit ID: 0"                         
                     ]
                },
                {
                    "name " : "Johny Deep",
                    "date " : "June 08, 2021",
                    "time" : "4:00 PM",
                     "comment" :[                         
                         "Order Circuit Required Date: From: TO: June  07, 2021 at 4:00PM"
                     ]
                }
            ],
            statusList:[
                {
                    "status":"Order Created",
                    "dateCompleted": "29/09/2022"
                },
                {
                    "status":"Order Submitted"                
                },
                {
                    "status":"Order Receipt Confirmed"                    
                },
                {
                    "status":"Circuit Installed"                    
                }

            ],

        }
    }

    getDataSelected(data) {
        this.setState({selectedIndex:data})
       
    }

    openLineItem(data) {
        this.setState({tableSelected:data})
    }

    CloseForm() {       
        this.props.closeForm(false)
     }




    render(){   
              
        return(

            <ManageLayout customClassName="manage-order-circuit-summary" buttonLabel="Back to Ciruit Details" haveStatusLabel={false} onGetSelected={this.getDataSelected.bind(this)} statusList={this.state.statusList} closeForm={this.props.closeForm} listData={this.state.listTabInfo.Tab} haveHeaderButton={false}>

                {
                    this.state.selectedIndex===Selected_Index.i_Zero &&
                        <>
                            <div className="manage-order-container">
                                <h1>Order Details</h1>
                                <div className="custom-col-6">
                                    <h2>SR Number</h2>
                                    <h2>Order Number</h2>
                                    <h2>Requestor Email</h2>
                                    <h2>Requestor Owner Email</h2>
                                    <h2>Request Type</h2>
                                    <h2>Request Date</h2>                                    
                                    <span>-</span>
                                    <span>TEM20221000</span>
                                    <span>sample@email.com</span>
                                    <span>-</span>
                                    <span>OTHER</span>
                                    <div className="date-circuit-container">
                                        <span>10/07/2022 at 12:28:40</span>
                                        <span>10/07/2022 at 12:28:40</span>
                                    </div>
                                   
                                </div>
                                <div className="custom-col-2">
                                   
                                    <h2>Total MRC</h2>
                                    <h2>Request NRC</h2>
                                    
                                    <span>EUR 3</span>
                                    <span>EUR 0</span>

                                </div>
                             </div>
                             
                             <div className="manage-order-container">
                                <h1>Circuit Details(Primary)</h1>
                                <div className="custom-col-6">
                                    <h2>Vendor</h2>
                                    <h2>Billing Account #</h2>
                                    <h2>Circuit ID</h2>
                                    <h2>Circuit Type</h2>
                                    <h2>Sub-Circuit Type</h2>
                                    <h2>MRC</h2>                                    
                                    <span>TIM-fnOOkie(IT)</span>
                                    <span>TIM-fnOOkie(IT)-Bank Account Number</span>
                                    <span>32582_2</span>
                                    <span>Maintenance-Services</span>
                                    <span>Power</span>
                                    <span>EUR 3</span>                                   
                                </div>
                                <div className="custom-col-1">                                   
                                    <h2>NRC</h2>                                    
                                    <span>EUR 0</span>
                                </div>
                                <h1>Plan Details</h1>
                                <div className="custom-col-2">
                                    <h2>Plan Name</h2>
                                    <h2>Plan Components + MRC</h2>
                                    <span>Test</span>
                                    <span>Test</span>
                                </div>
                             </div>  
                               
                             <div className="manage-order-container">
                                <h1>Location Information</h1>
                                <div className="custom-col-5">
                                    <h2>Billing Address</h2>
                                    <h2>Service Location 1</h2>
                                    <h2>Demarc Location 1</h2>
                                    <h2>Service Location 2</h2>
                                    <h2>Demarc Location 2</h2>                                    
                                    <span>Virtual Building for Italy, Not in EntityClient premesis 6549000, Not in EntityClient premises 6000, Italy</span>
                                    <span>-</span>
                                    <span>-</span>
                                    <span>-</span>
                                    <span>-</span>                                    
                                </div>  
                                <div className="custom-col-3">
                                    <h2>Location Contact Email Address</h2>
                                    <h2>Location Contact Full Name</h2>
                                    <h2>Location Contact Phone #</h2>                                    
                                    <span>sample@email.com</span>
                                    <span>Marie Zerna</span>
                                    <span>094657641</span>
                                </div>
                                <div className="custom-col-3">
                                   
                                    <h2>Alternate Local Contact Email Address</h2>
                                    <h2>Alternate Local Contact Full Name</h2>
                                    <h2>Alternate Local Contact Phone #</h2>
                                    <span>-</span>
                                    <span>-</span>
                                    <span>-</span>
                                </div>   
                                <div className="custom-col-3">                                    
                                    <h2>Technical Contact Email Address</h2>                                   
                                    <h2>Technical Contact Full Name</h2>
                                    <h2>Technical Contact Phone #</h2>
                                    <span>-</span>
                                    <span>-</span>
                                    <span>-</span>
                                </div> 
                                <div className="custom-col-3">
                                    <h2>Alternate Technical Contact Email Address</h2>                                   
                                    <h2>Alternate Technical Contact Full Name</h2>
                                    <h2>Alternate Technical Contact Phone #</h2>
                                    <span>-</span>
                                    <span>-</span>
                                    <span>-</span>
                                </div>                          
                             </div>  
                             <div className="manage-order-container">
                                <h1>Business Justification</h1>
                                <div className="custom-col-5">
                                    <h2>GL Code</h2>
                                    <h2>Cost Center</h2>
                                    <h2>Expedite Request</h2>
                                    <h2>Business Justification</h2>
                                    <h2>Additional Information</h2>
                                    <span>JENTESTI</span>
                                    <span>CCY1</span>
                                    <span>Yes</span>
                                    <span>Lorem ipsum test test</span>
                                    <span>Lorem ipsum test test</span>
                                </div>                                
                             </div>  
                             <div className="save-btn-container">
                                 <Button className="save-button" onClick={this.CloseForm}> Back to Order Details </Button>  
                             </div>                                
                        </>
                }

                {
                    this.state.selectedIndex===Selected_Index.i_One &&
                    <OrderEmailValidator selectFilter={this.state.selectFilter} datatable={this.state.dataTable}/>
                }

                {
                    this.state.selectedIndex===Selected_Index.i_Two &&
                    < InvoiceHistory dataInfo={this.state.dataInfo}/>
                }

            </ManageLayout>
        )
    }
}